import Vue from 'vue';

export default {

      async fetchDListInternalsByDprId({ commit }, dprId) {
        return Vue.axios.get(Vue.$url("distribution-list-int/"+ dprId + "/available"))
          .then((rsp) => commit("SET_DLISTINTERNAL", rsp.data))
          
      }

}